import React, { Component } from "react";
import Table from "../common/table";
import { createClientColumns } from "./clientColumns";

class ClientTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elevated: false,
      currentYear: new Date().getFullYear(),
    };

    // Create columns with handlers
    this.columns = createClientColumns({
      setClicked: props.setClicked,
      handleAttestBtnDisable: this.handleAttestBtnDisable,
    });
  }

  handleAttestBtnDisable = (client) => {
    // Guard against undefined/null client or missing accounts
    if (!client || !client.accounts) {
      return true; // Disable button if client data is invalid
    }

    const { gracePeriod } = this.props;
    let disable = true;

    const hasUnsubmitted = (yearKey) => {
      if (!client.accounts[yearKey]) return false;
      let found = false;
      Object.keys(client.accounts[yearKey]).forEach((custodianKey) => {
        client.accounts[yearKey][custodianKey].forEach((account) => {
          if (
            (typeof account.submitted === "string" &&
              account.submitted !== "true") ||
            (typeof account.submitted === "boolean" &&
              account.submitted !== true)
          ) {
            found = true;
          }
        });
      });
      return found;
    };

    if (gracePeriod && client.accounts["Previous"]) {
      // During grace period, check both Previous and Current accounts
      if (hasUnsubmitted("Previous") || hasUnsubmitted("Current")) {
        disable = false;
      }
    } else if (client.accounts["Current"]) {
      if (hasUnsubmitted("Current")) {
        disable = false;
      }
    }
    return disable;
  };

  componentDidMount = () => {
    const groups = this.props.groups;
    const groupLogic =
      groups.includes("compliance") || groups.includes("system_admin");
    if (groupLogic) {
      this.setState({ elevated: true });
    }
    this.props.updateColumnList(this.columns);
  };

  render() {
    const {
      clients,
      onSort,
      sortColumn,
      filterState,
      onFilterChange,
      defaultFilterOptions,
      allClients, // Full dataset for filter option generation
      financialProfessionals, // FP list for advisor column filter
      externalOpenFilter,
      onExternalFilterOpened,
      attestColumnFirst,
    } = this.props;

    const displayColumns = attestColumnFirst
      ? [this.columns[this.columns.length - 1], ...this.columns.slice(0, -1)]
      : this.columns;

    return (
      <div>
        <Table
          updateColumnList={this.props.updateColumnList}
          columns={displayColumns}
          data={clients}
          allData={allClients} // Full dataset for filter option generation
          sortColumn={sortColumn}
          onSort={onSort}
          filterState={filterState}
          onFilterChange={onFilterChange}
          defaultFilterOptions={defaultFilterOptions}
          financialProfessionals={financialProfessionals}
          externalOpenFilter={externalOpenFilter}
          onExternalFilterOpened={onExternalFilterOpened}
        />
      </div>
    );
  }
}

export default ClientTable;
